// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"291":"b62abe64ba4ebf68e89b","825":"3a4aff0e743a7540fe25"}[chunkId] + ".js";
};